module.exports = __webpack_public_path__ + "img/app-lieqi.9c527c48.png";